const POSTS_PER_PAGE = 5;

export { POSTS_PER_PAGE };
